export type GmapsPolygon = google.maps.Polygon

export interface BasePoly {
    id?: number | null
    name: string
    description: string
    color: string
}

export interface KymarkPolygon extends BasePoly {
    ref: GmapsPolygon
    key: string | number
    selected?: boolean
}

export type Zone = Override<BasePoly, {
    id: number
    polygon: ClipPolygon
}>

export type LatLngPair = [latitude: number, longitude: number]
export type PolyRing = LatLngPair[]
export type ClipPolygon = PolyRing[]

function latLngPairToObj([lat, lng]: LatLngPair) {
    return {lat, lng}
}

function gmapPolyToLatLng(poly: GmapsPolygon): google.maps.ReadonlyLatLngLiteral[] {
    return poly.getPath().getArray().map(latlng => latlng.toJSON())
}

export function gmapPolyToClipPoly(poly: GmapsPolygon): ClipPolygon {
    return poly.getPaths().getArray().map(ring => ring.getArray().map(latlng => [latlng.lat(), latlng.lng()]))
}

function polyRingToGmapPath(poly: PolyRing): google.maps.ReadonlyLatLngLiteral[] {
    return poly.map(([lat, lng]) => ({lat, lng}))
}

export function clipPolyToGmapPath(poly: ClipPolygon): google.maps.ReadonlyLatLngLiteral[][] {
    return poly.map(p => polyRingToGmapPath(p))
}

export const POLY_OPTS = Object.freeze({
        strokeOpacity: 0.8,
        fillOpacity: 0.35,
        geodesic: false,
    }
)
